const header = require('./includes/header')
const bottombar = require('./includes/bottombar')
const readmore = require('./includes/read-more')
const bannerRightSide = require('./includes/banner-right-side')
const bannerMainThumbnail = require('./includes/banner-main-with-thumbnail')
const bannerWithBlur = require('./includes/banner-main-with-blur');
const slideVerticalMenuService = require('./includes/slide-vertical-menu-service')

const homePage = require('./pages/homepage')
const aboutDoctorPage = require('./pages/about/about-doctor')
const aboutOverview = require('./pages/about/overview')
const aboutMenu = require('./pages/about/about-menu')
const aboutEyeMenuVertical = require('./pages/about-eyes/menu-vertical')
const serviceAdvantages = require('./pages/services/slide-advantages')
const serviceSlideIcon = require('./pages/services/slide-icon')
const influencer = require('./pages/services/influencer')
const verticalMenuService = require('./pages/services/vertical-menu-service');
const serviceCondition = require('./pages/services/service-condition');
const faq = require('./pages/faq/index');
const initCopyElement = require('./includes/copy-element')

const slideServiceAbout = () => {
    $('.slide-service').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
        ]
    });

}

const slide = ($select, options = {}) => {
    $($select).slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        ],
        ...options
    });
}


$("document").ready(function () {
    slideServiceAbout();
    slide('.slide-equipment');
    slide('.first-slide-equipment', {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    //components
    header();
    bottombar();
    readmore();
    bannerRightSide();
    bannerMainThumbnail();
    bannerWithBlur();
    slideVerticalMenuService();

    //pages
    homePage();
    aboutDoctorPage();
    aboutOverview();
    aboutMenu();

    aboutEyeMenuVertical();
    serviceAdvantages();
    serviceSlideIcon();
    influencer();
    verticalMenuService();
    serviceCondition();
    faq();
    initCopyElement();

    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    const lazyContent = new LazyLoad({
        load_delay: 1000,
        effect : "fadeIn"
    });
})

$(window).resize(function () {
    //headerMenu()
})
